import {
  Divider,
  FormControl,
  FormControlLabel,
  GKButton,
  GKRadio,
  GKTextField,
  Grid2,
  PlusIcon,
  RadioGroup,
  Show,
  Typography,
} from "components";
import { EyeIcon, RupeeIcon } from "components/Icons";
import { sum } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { numberToCurrency } from "utils";

const InvestmentTab = () => {
  const form = useFormContext();

  // const location = useLocation();

  const aumBasedPlanWatch = form.watch("planDataObject.aumBasedPlan");
  const aumCashWatch = form.watch("planDataObject.aumCash");
  // const skipPayment =
  //   new URLSearchParams(location.search).get("skip_advance_fee") === "True";
  // const feePlanDetails = form.getValues("clientObject.advanceFeePlan.feePlan");

  // useEffect(() => {
  //   form.setValue("planDataObject.aumBasedPlan", "");
  // }, []);

  // const handleRetuneFeeAndInvestmentValue = () => {
  //   if (!isEmpty(feePlanDetails?.managementFee)) {
  //     if (feePlanDetails?.managementFee?.feeType !== "Flat Fee") {
  //       return `We charge an AUA based fee of ${feePlanDetails?.managementFee?.fee}% annually for this basket, only users with a minimum investment of ${numberToCurrency(Number(feePlanDetails?.managementFee?.minimumInvestment))} can subscribe.`;
  //     }

  //     if (feePlanDetails?.managementFee?.feeType === "Flat Fee") {
  //       return `We charge a flat fee of ${numberToCurrency(feePlanDetails?.managementFee?.fee)} for ${form.getValues("basketObject.name")}`;
  //     }
  //   }

  //   if (isEmpty(feePlanDetails?.managementFee)) {
  //     if (feePlanDetails?.advanceDeposit?.feeType !== "Flat Fee") {
  //       return `We charge an AUA based fee of ${feePlanDetails?.advanceDeposit?.fee}% annually for this basket, only users with a minimum investment of ${numberToCurrency(Number(feePlanDetails?.advanceDeposit?.minimumInvestment))} can subscribe.`;
  //     }

  //     if (feePlanDetails?.advanceDeposit?.feeType === "Flat Fee") {
  //       return `We charge a flat fee of ${numberToCurrency(feePlanDetails?.advanceDeposit?.fee)} for ${form.getValues("basketObject.name")}`;
  //     }
  //   }

  //   return "";
  // };

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={7} display={"flex"} flexDirection={"column"} gap={1}>
        <Typography
          fontSize={20}
          fontWeight={600}
          // pt={2}
          sx={{ fontSize: "clamp(1.125rem, 0.6563rem + 1.5vw, 1.5rem)" }}
        >
          Fill in your investment details
        </Typography>
      </Grid2>
      <Grid2
        size={5}
        display={"flex"}
        justifyContent={"flex-end"}
        alignItems={"start"}
      >
        <img
          src="/Logos/iconFullLogo.png"
          alt="GridKey Logo"
          style={{
            height: "32px",
            width: "auto",
          }}
        />
      </Grid2>

      {/* {!skipPayment && (
        <Grid2 size={12}>
          <Typography fontWeight={500} fontSize={12} color="#94A3B8">
            {handleRetuneFeeAndInvestmentValue()}
          </Typography>
        </Grid2>
      )} */}
      <Grid2 size={12}>
        <FormControl component="fieldset">
          <Controller
            name={"planDataObject.aumBasedPlan"}
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "*Please select one of above plan",
              },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <>
                  <RadioGroup
                    {...field}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      form.setValue("planDataObject.aumCash", "");
                      form.setValue("planDataObject.plansHoldings", [
                        {
                          gridCode: "",
                          quantity: 0,
                          cmp: "",
                          id: 0,
                          name: "",
                        },
                      ]);
                    }}
                  >
                    <FormControlLabel
                      value="withHoldings"
                      control={<GKRadio disableLeftPadding />}
                      label={
                        <Typography
                          fontSize={14}
                          fontWeight={400}
                          display="inline"
                        >
                          With existing holdings
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="withCash"
                      control={<GKRadio disableLeftPadding />}
                      label={
                        <Typography
                          fontSize={14}
                          fontWeight={400}
                          display="inline"
                        >
                          With fresh cash/capital
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="both"
                      control={<GKRadio disableLeftPadding />}
                      label={
                        <Typography
                          fontSize={14}
                          fontWeight={400}
                          display="inline"
                        >
                          Both
                        </Typography>
                      }
                    />
                  </RadioGroup>

                  {!!error && (
                    <Typography color="error" fontSize={12}>
                      {error?.message}
                    </Typography>
                  )}
                </>
              );
            }}
          />
        </FormControl>
      </Grid2>

      <Show.When
        isTrue={
          aumBasedPlanWatch === "both" || aumBasedPlanWatch === "withHoldings"
        }
      >
        <Grid2 size={12}>
          <Typography fontSize={14} fontWeight={700} color="var(--black-900)">
            With existing holdings
          </Typography>
          <Typography
            fontSize={12}
            fontWeight={500}
            color="var(--neutral-500)"
            mt={0.5}
          >
            You can either add data manually or upload an Excel file.
          </Typography>
        </Grid2>
        <Grid2
          size={12}
          mt={2}
          display={"flex"}
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={{ xs: "flex-start", md: "space-between" }}
          gap={{ xs: 2, md: 2 }}
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <GKButton
            variant="outlined"
            startIcon={
              form.getValues("planDataObject.plansHoldings")[0]?.gridCode !==
              "" ? (
                <EyeIcon />
              ) : (
                <PlusIcon />
              )
            }
            color="dark"
            sx={{ width: { xs: "100%", md: "auto" } }}
            onClick={() => {
              form.setValue("planDataObject.showHoldingsModal", true);
            }}
          >
            {form.getValues("planDataObject.plansHoldings")[0]?.gridCode !== ""
              ? "View Holdings"
              : "Add Data / Upload Excel"}
            {/* Add Data / Upload Excel */}
          </GKButton>
          <Show.When isTrue={aumBasedPlanWatch !== "both"}>
            <Typography
              fontSize={14}
              fontWeight={500}
              color="var(--neutral-700)"
            >
              Total investment value:{" "}
              <span style={{ fontWeight: 600 }}>
                {numberToCurrency(
                  +aumCashWatch +
                    sum(
                      form
                        .getValues("planDataObject.plansHoldings")
                        .map(
                          (d: { cmp: string; quantity: string }) =>
                            +d.cmp * +d.quantity,
                        ),
                    ),
                )}
              </span>
            </Typography>
          </Show.When>
        </Grid2>
      </Show.When>
      <Show.When
        isTrue={
          aumBasedPlanWatch === "both" || aumBasedPlanWatch === "withCash"
        }
      >
        <Grid2 size={12}>
          <Divider sx={{ mt: 2, mb: 3 }} />
          <Typography fontSize={14} fontWeight={700} color="var(--black-900)">
            With fresh cash/capital
          </Typography>
          <Typography
            fontSize={12}
            fontWeight={700}
            color="var(--neutral-500)"
            mt={0.5}
          >
            Enter the amount you want to invest using fresh cash/capital.
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Controller
            control={form.control}
            name="planDataObject.aumCash"
            rules={{
              required: {
                message: "Please enter a valid amount",
                value:
                  form.getValues("planDataObject.aumBasedPlan") === "both" ||
                  form.getValues("planDataObject.aumBasedPlan") === "withCash",
              },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKTextField
                  {...field}
                  type="number"
                  placeholder="Enter Cash Amount"
                  slotProps={{
                    input: {
                      endAdornment: <RupeeIcon />,
                    },
                  }}
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
        </Grid2>
        {/* <Grid2 size={12}>
          <Card sx={{ p: 2 }}>
            <Grid2 container>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography fontWeight={600}>
                  With fresh cash/capital
                </Typography>
                <Typography color={blueGrey[600]}>
                  Add the fresh capital amount you want to invest.
                </Typography>
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 6 }}
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  justifyContent: {
                    xs: "center",
                    md: "flex-end",
                  },
                }}
              >
                <Controller
                  control={form.control}
                  name="planDataObject.aumCash"
                  rules={{
                    required: {
                      message: "Please enter a valid amount",
                      value:
                        form.getValues("planDataObject.aumBasedPlan") ===
                          "both" ||
                        form.getValues("planDataObject.aumBasedPlan") ===
                          "withCash",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <GKTextField
                        {...field}
                        type="number"
                        fullWidth={false}
                        placeholder="Enter Cash Amount"
                        error={!!error}
                        helperText={error?.message}
                      />
                    );
                  }}
                />
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>{" "} */}
      </Show.When>
      <Show.When isTrue={aumBasedPlanWatch === "both"}>
        <Grid2
          size={12}
          bgcolor={"#EEF5FA"}
          display={"flex"}
          padding={"16px 12px"}
          mt={2.5}
        >
          <Typography fontSize={14} fontWeight={500} color="var(--neutral-700)">
            Total investment value:{" "}
            <span style={{ fontWeight: 600 }}>
              {numberToCurrency(
                +aumCashWatch +
                  sum(
                    form
                      .getValues("planDataObject.plansHoldings")
                      .map(
                        (d: { cmp: string; quantity: string }) =>
                          +d.cmp * +d.quantity,
                      ),
                  ),
              )}
            </span>
          </Typography>
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default InvestmentTab;
